export const LEAD_UPDATE_SUCCESS = 'Lead updated successfully';
export const SOMETHING_WENT_WRONG = 'Something went wrong';